export default "__VITE_ASSET__64d1db16__"